import {
  manageReader,
  signIn,
  signInLight,
} from "@bindery/auth-consumer/browser";

// Navigations that name a reader are same-origin form POSTs inside these
// helpers: Safari 14 sends no Sec-Fetch-Site, so a link carrying a readerId
// cannot prove it came from this app and auth-consumer refuses it.
export interface AuthActions {
  signIn: typeof signIn;
  signInLight: typeof signInLight;
  manageReader: typeof manageReader;
}

export const browserAuthActions: AuthActions = {
  signIn,
  signInLight,
  manageReader,
};
